/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  LOAD_COUNTRY,
  LOAD_COUNTRIES_REQUEST,
  LOAD_COUNTRIES_SUCCESS,
  LOAD_COUNTRIES_FAILLURE,
} from "../actions/countriesActions";

const initialState = {
  countries: [],
};

const countriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_COUNTRIES_REQUEST: {
      return produce(state, (draft) => {
        // Ensure we clear current session
        draft.countries = null;
      });
    }

    case LOAD_COUNTRIES_SUCCESS: {
      const { countries, activeCountry } = action.payload;
      return produce(state, (draft) => {
        draft.countries = countries;
        draft.activeCountry = activeCountry;
      });
    }

    case LOAD_COUNTRY: {
      const { selectedCountry } = action.payload;
      return produce(state, (draft) => {
        draft.selectedCountry = selectedCountry;
      });
    }

    case LOAD_COUNTRIES_FAILLURE: {
      return produce(state, (draft) => {
        draft.countries = null;
      });
    }

    default: {
      return state;
    }
  }
};

export default countriesReducer;
